import { useQuery } from "@tanstack/react-query";
import apiClient from "@/api/apiClient";
import { ENDPOINTS } from "@/api/endpoints";

// Query Keys
export const roomCalendarKeys = {
  all: ["roomCalendar"],
  byDay: (dayOfWeek) => ["roomCalendar", "day", dayOfWeek],
};

/**
 * Fetches room calendar data enriched with availability and services for a given day of week.
 * @param {number} dayOfWeek - 0 (Sunday) through 6 (Saturday)
 */
export const useRoomCalendarData = (dayOfWeek) => {
  return useQuery({
    queryKey: roomCalendarKeys.byDay(dayOfWeek),
    queryFn: () =>
      apiClient.get(
        `${ENDPOINTS.SETTINGS.ROOMS_CALENDAR_DATA}?dayOfWeek=${dayOfWeek}`
      ),
    enabled: dayOfWeek != null && dayOfWeek >= 0 && dayOfWeek <= 6,
    staleTime: 5 * 60 * 1000, // 5 minutes - room config doesn't change often
  });
};
